import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
export const PerfectForSection = () => {
  const venues = [{
    name: 'Restaurants',
    description: 'Elevate every table with premium water service',
    link: '/restaurants',
    comingSoon: false
  }, {
    name: 'Offices & Co-Working Spaces',
    description: 'Premium hydration for productive workspaces',
    link: '/offices',
    comingSoon: true
  }, {
    name: 'Hotels',
    description: 'Luxury hydration for discerning guests',
    link: '/hotels',
    comingSoon: true
  }, {
    name: 'Cafés & Coffee Bars',
    description: 'Perfect water for perfect coffee',
    link: '/cafes',
    comingSoon: true
  }, {
    name: 'Spas, Wellness & Healthcare',
    description: 'Pure alkaline water for wellbeing and patient care',
    link: '/wellness',
    comingSoon: true
  }, {
    name: 'Condominiums',
    description: 'Premium amenities that residents love',
    link: '/condominiums',
    comingSoon: true
  }, {
    name: 'Luxury Retail & Showrooms',
    description: 'An experience guests remember',
    link: '/retail',
    comingSoon: true
  }];
  return <section className="py-16 md:py-32 water-gradient" data-id="element-172">
      <div className="container mx-auto px-4 md:px-6 lg:px-12" data-id="element-173">
        <div className="text-center mb-8 md:mb-16 max-w-3xl mx-auto" data-id="element-174">
          <h2 className="text-3xl md:text-6xl font-light mb-4 md:mb-6" data-id="element-175">
            Made for Modern Spaces
          </h2>
          <p className="text-base md:text-xl text-gray-600 font-light leading-relaxed" data-id="element-176">
            Perfect for businesses that sell premium water or need to impress
            clients with exceptional hospitality.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 max-w-6xl mx-auto" data-id="element-177">
          {venues.map((venue, index) => venue.comingSoon ? <div key={index} className="glass-card p-6 md:p-8 rounded-xl md:rounded-2xl text-center space-y-2 md:space-y-3 relative opacity-75" data-id="element-178">
                <div className="absolute top-4 right-4 bg-gray-900 text-white text-xs px-3 py-1 rounded-full" data-id="element-179">
                  Coming Soon
                </div>
                <h3 className="text-lg md:text-xl font-medium text-gray-700" data-id="element-180">
                  {venue.name}
                </h3>
                <p className="text-xs md:text-sm text-gray-600" data-id="element-181">
                  {venue.description}
                </p>
              </div> : <Link key={index} to={venue.link} className="glass-card p-6 md:p-8 rounded-xl md:rounded-2xl text-center space-y-2 md:space-y-3 group hover:shadow-xl transition-all duration-300 cursor-pointer" data-id="element-182">
                <h3 className="text-lg md:text-xl font-medium group-hover:text-water-accent transition-colors" data-id="element-183">
                  {venue.name}
                </h3>
                <p className="text-xs md:text-sm text-gray-600" data-id="element-184">
                  {venue.description}
                </p>
                <div className="flex items-center justify-center gap-2 text-sm text-gray-500 group-hover:text-water-accent transition-colors pt-2" data-id="element-185">
                  <span data-id="element-186">Learn more</span>
                  <ArrowRightIcon size={16} className="group-hover:translate-x-1 transition-transform" data-id="element-187" />
                </div>
              </Link>)}
        </div>
      </div>
    </section>;
};